module.exports = __webpack_public_path__ + "static/img/money_light.a89b504d.png";